import ReactECharts from "echarts-for-react";
import { useState, useEffect } from "react";
import { RefreshCcw } from "react-feather";
import { getStatusWiseJob } from "../../api/transporterDashboardApi";
import LoadingSpinner from "../../components/LoadingSpinner";

const JobStatusChart = ({ userId, transporter, fromDate, toDate, refreshTrigger }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [localRefresh, setLocalRefresh] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      setError(null);
      try {
        const ids = transporter && transporter.length > 0 ? transporter : null;
        const result = await getStatusWiseJob(userId, fromDate, toDate, ids);
        setData(Array.isArray(result) ? result : []);
      } catch (err) {
        setError("Failed to load job status data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [userId, transporter, fromDate, toDate, refreshTrigger, localRefresh]);

  const option = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)",
    },
    legend: { show: false },
    series: [
      {
        name: "Job Status",
        type: "pie",
        radius: ["38%", "68%"],
        center: ["50%", "50%"],
        avoidLabelOverlap: true,
        itemStyle: { borderRadius: 6, borderColor: "#fff", borderWidth: 2 },
        label: {
          show: true,
          position: "outside",
          formatter: "{b}\n{c} ({d}%)",
          fontSize: 11,
          lineHeight: 16,
        },
        labelLine: { show: true, length: 10, length2: 8 },
        data: data.map((d) => ({ name: d.status, value: d.count })),
        emphasis: { itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.2)" } },
      },
    ],
  };

  return (
    <div
      className="ui segment"
      style={{ boxShadow: "rgba(149,157,165,0.2) 0px 8px 24px", margin: "0px 0" }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3>Job Status Distribution</h3>
        <RefreshCcw size={16} style={{ cursor: "pointer" }} onClick={() => setLocalRefresh((k) => k + 1)} />
      </div>
      {loading ? (
        <div style={{ height: "380px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <LoadingSpinner />
        </div>
      ) : error ? (
        <div style={{ height: "380px", display: "flex", alignItems: "center", justifyContent: "center", color: "#dc2626", fontSize: "13px" }}>
          {error}
        </div>
      ) : data.length === 0 ? (
        <div style={{ height: "380px", display: "flex", alignItems: "center", justifyContent: "center", color: "#aaa", fontSize: "14px" }}>
          No data available
        </div>
      ) : (
        <ReactECharts option={option} style={{ width: "100%", height: "380px" }} />
      )}
    </div>
  );
};

export default JobStatusChart;